import { React,  DomeComponent, DomeManipulator } from '@lexriver/dome'
import { ErrorForInput } from './ErrorForInput'
import css from './SelectRadio.m.scss'

export interface SelectRadioItem{
    value:string
    text:string|HTMLElement|DocumentFragment
    selected?:boolean
}


interface Attrs{
    name:string
    legend:string
    values:SelectRadioItem[]
    onChange?:(value:string)=>void
}

export class SelectRadio extends DomeComponent<Attrs>{
    //changeEvent = new TypeEvent<(value:string)=>void>()
    refErrorForInput?:ErrorForInput

    refContainer!:HTMLFieldSetElement

    render(){
        return <>
            <fieldset ref={ref => this.refContainer = ref}>
            <legend>{this.attrs.legend}</legend>
            {this.attrs.values.map(item => 
                <div>
                    <label>
                        <input 
                            type="radio" 
                            name={this.attrs.name} 
                            value={item.value} 
                            checked={item.selected?true:false} 
                            onChange={async () => await this.onChangeAsync(item.value)}
                        ></input>{item.text}
                    </label>
                </div>
            )}
        </fieldset>
        <ErrorForInput ref={ref => this.refErrorForInput = ref} />
        </>
    }

    async onChangeAsync(newValue){
        await this.hideErrorAsync()
        this.attrs.onChange && this.attrs.onChange(newValue)
    }


    selectByValue(valueToSelect:string){
        this.refContainer.querySelectorAll(`input[type=radio]`).forEach(input => {
            if(input.getAttribute("value") == valueToSelect){
                // select item
                input.setAttribute("checked", "checked")
            } else {
                input.removeAttribute("checked")
            }
        })
    }

    getSelectedValue():string|undefined{
        const checkedInput:HTMLInputElement|null = this.refContainer.querySelector('input:checked')
        if(checkedInput){
            return checkedInput.value
        }
        return undefined
    }

    disable(){
        this.refContainer.querySelectorAll('input').forEach(input => input.disabled = true)
    }

    enable(){
        this.refContainer.querySelectorAll('input').forEach(input => input.disabled = false)
    }

    async hideErrorAsync(){
        //if(!this.refErrorForInput) return
        await this.refErrorForInput?.hideAsync()
    }


    async showErrorAsync(errorMessage:string|HTMLElement){
        //if(!this.refErrorForInput) return
        if(!this.refContainer) return
        await this.refErrorForInput?.showAsync(errorMessage)
        
        DomeManipulator.scrollIntoView(this.refContainer)
        
        
    }

}